'use client'
import { LicenceControlSettings } from '@repo/ui/LicenceControlSettings'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import MUIStack from '@mui/material/Stack'

const LicenceControl = () => {
  const { pageTitleBlockIsVisible } = useGlobalSettingsStore()

  return (
    <MUIStack
      data-testid="LicenceControl"
      gap={6}
      sx={{
        maxWidth: 680,
        mx: 'auto',
        mt: pageTitleBlockIsVisible ? 0 : '10rem',
        backgroundColor: 'white',
        borderRadius: '6px',
        padding: '1rem 2rem 2rem'
      }}
    >
      <LicenceControlSettings />
    </MUIStack>
  )
}

export default LicenceControl
